import styled from "styled-components";

export const PayoffModalContentWrapper = styled.div`
  margin: 10px;
`;
